module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-slider-right-890454e705ab267c1feae00cf3dd57e9.svg";